import React, { Component } from "react";
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import classnames from 'classnames';

import { Modal } from "semantic-ui-react";

import { closeAuthPhoneModal } from "../../../redux/actions/ui";
import {
  signInAsync,
  confirmPhoneAsync,
  updateCodeValues,
  updateRemainingSeconds
} from "../../../redux/actions/auth";

const mapStateToProps = state => ({
  ...state.auth,
  authPhoneModal: state.ui.authPhoneModal,
});

const mapDispatchToProps = dispatch => ({
  closeAuthPhoneModal: () => dispatch(closeAuthPhoneModal()),
  resendCode: (login, password) => dispatch(signInAsync(login, password, true)),
  confirmPhone: code => dispatch(confirmPhoneAsync(code)),
  onUpdateCodeValues: (field, value) => dispatch(updateCodeValues(field, value)),
  onCountDown: seconds => dispatch(updateRemainingSeconds(seconds)),
});

class AuthPhoneModal extends Component {
  static propTypes = {
    login: PropTypes.string.isRequired,
    password: PropTypes.string.isRequired,
    authPhoneModal: PropTypes.object.isRequired,
    phoneNumber: PropTypes.string.isRequired,
    codeError: PropTypes.bool.isRequired,
    codeServerError: PropTypes.bool.isRequired,
    serverError: PropTypes.bool.isRequired,
    closeAuthPhoneModal: PropTypes.func.isRequired,
    confirmPhone: PropTypes.func.isRequired,
    resendCode: PropTypes.func.isRequired,
  };

  constructor() {
    super();
    this.state = {
      codeWasSent: true,
      formWasSent: false,
    };
    this.timer = null;
    this.inputRef1 = React.createRef();
    this.inputRef2 = React.createRef();
    this.inputRef3 = React.createRef();
    this.inputRef4 = React.createRef();
  }

  //Запустит таймер, как только модалка откроется
  componentDidUpdate = (prevProps) => {
    const { authPhoneModal, tempToken, phoneNumber, seconds } = this.props;
    //Таймер стартует при открытии модалки или при изменении тех параметров,
    //которые приходят при первом запросе на авторизацию: tempToken, phoneNumber, seconds
    if (((prevProps.authPhoneModal.isOpen !== authPhoneModal.isOpen) && authPhoneModal.isOpen) ||
      (prevProps.tempToken !== tempToken) ||
      (prevProps.phoneNumber !== phoneNumber) ||
      (prevProps.seconds !== seconds)
    ) this.startTimer();
    //При закрытии модалки останавливаем таймер
    if (((prevProps.authPhoneModal.isOpen !== authPhoneModal.isOpen) && !authPhoneModal.isOpen)) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  //Склеивает из 4 полей код и отсылает на сервер
  createCodeConfirmPhone = (val1, val2, val3, val4) => {
    const { confirmPhone } = this.props;
    const codeVal = `${val1}${val2}${val3}${val4}`;
    if (codeVal.length === 4) confirmPhone(codeVal);
  }

  startTimer = () => {
    const { seconds } = this.props;
    if ((this.timer === null) && (seconds > 0)) {
      //Раз в секунду будет вызываться countDown
      this.timer = setInterval(this.countDown, 1000)
    }
  }

  //Обратный отсчет таймера
  //Убирает по одной секунде с отображаемого счетчика
  countDown = () => {
    const { seconds, onCountDown } = this.props;
    let newSeconds = seconds - 1;
    onCountDown(newSeconds);
    //Сброс таймера
    if (newSeconds === 0) {
      this.setState({ codeWasSent: false });
      onCountDown(60);
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  //Повторная отправка на сервер логина и пароля
  //Для получения новых временного токена и кода
  onSendNewCode = () => {
    const { login, password, resendCode } = this.props;
    this.setState({ codeWasSent: true });
    resendCode(login, password);
    this.startTimer();
  }

  onChangeInput = (field, value) => {
    const { val1, val2, val3, val4, onUpdateCodeValues } = this.props;
    value = value.replace(/[^0-9]/g, '');
    onUpdateCodeValues(field, value);
    if (value.length !== 0) {
      switch (field) {
        case 'val1':
          this.inputRef2.current.focus();
          if ((val2.length > 0) && (val3.length > 0) && (val4.length > 0)) {
            this.createCodeConfirmPhone(value, val2, val3, val4);
          }
          break;
        case 'val2':
          this.inputRef3.current.focus();
          if ((val1.length > 0) && (val3.length > 0) && (val4.length > 0)) {
            this.createCodeConfirmPhone(val1, value, val3, val4);
          }
          break;
        case 'val3':
          this.inputRef4.current.focus();
          if ((val1.length > 0) && (val2.length > 0) && (val4.length > 0)) {
            this.createCodeConfirmPhone(val1, val2, value, val4);
          }
          break;
        case 'val4':
          this.inputRef1.current.focus();
          if ((val1.length > 0) && (val2.length > 0) && (val3.length > 0)) {
            this.createCodeConfirmPhone(val1, val2, val3, value);
          }
          break;
        default:
          this.inputRef1.current.focus();
          break;
      }
    }
  }

  render() {
    const {
      authPhoneModal,
      phoneNumber,
      codeError,
      codeServerError,
      serverError,
      closeAuthPhoneModal,
      val1,
      val2,
      val3,
      val4,
      seconds
    } = this.props;
    const { codeWasSent  } = this.state;

    const btnClass = classnames({
      'btn': true,
      'btn-green': true,
      'disabled': codeWasSent,
    });

    const userPhone = (phoneNumber[0] === '+') ? phoneNumber : `+${phoneNumber}`;
    let errorText = '';
    if (codeError && !codeServerError && !serverError) errorText = 'Ошибка: неверный код';
    else if ((codeServerError || serverError) && !codeError) errorText = 'Что-то пошло не так';

    return (
      <Modal className="auth-phone" open={authPhoneModal.isOpen}>
        <button type="button" className="btn-close modal-close" onClick={() => closeAuthPhoneModal()} />
        <h2>На номер {userPhone}<br />отправлено SMS с кодом</h2>
        <div className="code-inputs">
          <div className="inputs-wrap">
            <input
              type="text"
              maxLength="1"
              value={val1}
              onChange={(e) => this.onChangeInput('val1', e.target.value)}
              ref={this.inputRef1} 
            />
            <input
              type="text"
              maxLength="1"
              value={val2}
              onChange={(e) => this.onChangeInput('val2', e.target.value)}
              ref={this.inputRef2}
            />
            <input
              type="text"
              maxLength="1"
              value={val3}
              onChange={(e) => this.onChangeInput('val3', e.target.value)}
              ref={this.inputRef3}
            />
            <input
              type="text"
              maxLength="1"
              value={val4}
              onChange={(e) => this.onChangeInput('val4', e.target.value)}
              ref={this.inputRef4}
            />
          </div>
          {codeWasSent ? (<div className="code-text timer">Выслать код повторно через {seconds}</div>) : false}
          {codeError ? (
            <div className="code-text error">{errorText}</div>
          ) : false}
        </div>
        <Modal.Actions>
          <button
            type="button"
            className={btnClass}
            disabled={codeWasSent}
            onClick={() => this.onSendNewCode()}
          >
            Выслать код повторно
          </button>
        </Modal.Actions>
      </Modal>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AuthPhoneModal);
